"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APP_INSTALL_CONFLICT_CODES = void 0;
exports.createAppInstallConflict = createAppInstallConflict;
/**
 * Machine-readable reasons why an App cannot be added to a target App.
 * Clients render each code as a sentence plus recovery hint; the params carry
 * only display values (labels, paths), never schema fingerprints.
 */
exports.APP_INSTALL_CONFLICT_CODES = [
    'target_composition_missing',
    /** The plan allows no further App Container of the kind the App needs. */
    'app_container_limit_reached',
    /** The App Container would grow above the tables or Agent Actions of its plan. */
    'app_container_plan_quota_exceeded',
    /** An App Container listing names an App version the catalogue no longer offers. */
    'app_version_unavailable',
    'visibility_incompatible',
    'page_id_taken',
    'page_path_taken',
    'mount_point_taken',
    'app_route_taken',
    'database_decision_missing',
    'database_sharing_policy',
    'database_audience_mismatch',
    'database_incompatible',
    'database_not_found',
    'database_not_readable',
    'database_role_not_attachable',
    'database_column_unmapped',
    'database_column_unknown',
    'database_column_target_missing',
    'database_column_target_taken',
    'database_column_type_incompatible',
    'database_column_create_forbidden',
    'database_column_binding_fixed',
    'data_source_taken',
    'database_binding_taken',
    'database_relation_target_existing',
    'action_taken',
    'document_export_taken',
    'navigation_item_taken',
    'route_seo_taken',
    'interaction_control_taken',
    'artifact_file_taken',
    'route_module_taken',
    'seed_file_missing',
];
function createAppInstallConflict(code, params = {}, sourceKey) {
    return sourceKey ? { code, sourceKey, params } : { code, params };
}
